export const CONTENT_ACTIONS = {
  FAVORITE:"favorite",
  UNFAVORITE:"unfavorite",
} as const;
